import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Stack, Tooltip, Typography } from '@mui/material';

export function HeaderProdutosTooltip() {
    return (
        <Tooltip
            title={
                <Typography>
                    Produtos da configuração com <br />
                    <strong>sugestão importada</strong> e o <strong>total de produtos</strong>
                </Typography>
            }
            placement="top"
        >
            <Stack direction="row" spacing={0.5} sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography sx={{ fontWeight: 500, fontSize: '0.875rem' }}>Produtos</Typography>
                <InfoOutlinedIcon fontSize="small" />
            </Stack>
        </Tooltip>
    );
}
